<template>
  <div class="pointer-true">
    <div
      class="d-flex p-0 my-1 bg-light size-cell-container border rounded-circle"
      v-for="(value,index) in sizes"
      :key="value.id"
      :class="[{'selected-cell': index == selected}]"
      @click="ChangeSize(index)"
    >
      <div
        :style="{width: value + 'px', height: value +'px' }"
        class="m-auto bg-primary rounded-circle"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sizes: [24, 14, 8, 4, 2],
      selected: 3
    };
  },
  beforeMount() {
    window.addEventListener("keydown", this.KeyHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.KeyHandler);
  },
  methods: {
    KeyHandler(e) {
      let k = e.keyCode;
      // up arrow
      if (k == 38 || k == 87) {
        if (this.selected == 0) this.selected = this.sizes.length;
        this.ChangeSize(this.selected - 1);
        e.preventDefault();
      }
      // down arrow
      else if (k == 40 || k == 83) {
        if (this.selected == this.sizes.length - 1) this.selected = -1;
        this.ChangeSize(this.selected + 1);
        e.preventDefault();
      }
    },
    ChangeSize(index) {
      this.selected = index;
      this.$emit("change_size", this.sizes[index]);
    }
  }
};
</script>

<style scoped>
.size-cell-container {
  width: 26px;
  height: 26px;
}
.size-cell-container:hover {
  background: #00000030;
}
.selected-cell {
  box-shadow: 0px 0px 3px 1px #00aeff;
}
</style>